// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ItemResponse,
    ItemResponseFromJSON,
    ItemResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CareerSuggestedAssets
 */
export interface CareerSuggestedAssets {
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    careerTitle: string;
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof CareerSuggestedAssets
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    assetType: CareerSuggestedAssetsAssetTypeEnum;
    /**
     * 
     * @type {Array<ItemResponse>}
     * @memberof CareerSuggestedAssets
     */
    items?: Array<ItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CareerSuggestedAssets
     */
    seeMoreLink: string;
}

export function CareerSuggestedAssetsFromJSON(json: any): CareerSuggestedAssets {
    return {
        'title': json['title'],
        'careerTitle': json['career_title'],
        'description': json['description'],
        'order': json['order'],
        'assetType': json['asset_type'],
        'items': !exists(json, 'items') ? undefined : (json['items'] as Array<any>).map(ItemResponseFromJSON),
        'slug': json['slug'],
        'seeMoreLink': json['see_more_link'],
    };
}

export function CareerSuggestedAssetsToJSON(value?: CareerSuggestedAssets): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'title': value.title,
        'career_title': value.careerTitle,
        'description': value.description,
        'order': value.order,
        'asset_type': value.assetType,
        'items': value.items === undefined ? undefined : (value.items as Array<any>).map(ItemResponseToJSON),
        'slug': value.slug,
        'see_more_link': value.seeMoreLink,
    };
}

/**
* @export
* @enum {string}
*/
export enum CareerSuggestedAssetsAssetTypeEnum {
    Interactives = 'interactives',
    Pathways = 'pathways',
    SimpleCards = 'simple_cards',
    Clusters = 'clusters',
    FeatureCard = 'feature_card'
}


